module.exports = __webpack_public_path__ + "static/img/1ortho2.bf8aec2c.png";